import React from 'react';

import Waitlist from './Waitlist';
import LayoutGrid from '../../components/LayoutGrid';

async function action() {
  return {
    component: (
      <LayoutGrid>
        <Waitlist />
      </LayoutGrid>
    ),
  };
}

export default action;
